<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-dark">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img style="max-width: 350px" :src="'https://gamecomm.s3.amazonaws.com/logo-gamecomm.png'" alt="login"
                class="mx-auto mt-4" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Autenticação</h4>
                  <p>Informe seu Login e Senha.</p>
                </div>
                <form role="form" @submit.stop.prevent="onSubmit">
                  <vs-input name="login" icon="icon icon-user" icon-pack="feather" label-placeholder="Login"
                    v-model="form.login" class="w-full no-icon-border" v-validate="{ required: true }"
                    :state="validateState('Login')" :class="validateClass('Login')" />

                  <vs-input type="password" name="Senha" icon="icon icon-lock" icon-pack="feather"
                    label-placeholder="Senha" v-model="form.senha" v-validate="{ required: true }"
                    :state="validateState('Senha')" :class="validateClass('Senha')"
                    class="w-full mt-6 no-icon-border" />

                  <vue-recaptcha @verify="onRecaptchaVerified" :sitekey="sitekey" id="recaptcha" ref="recaptcha"
                    lang="pt-BR" class="w-full mt-6 no-icon-border"></vue-recaptcha>

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true"
                      class="my-3" style="height: auto !important">
                      <ul>
                        <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
                          {{ error }}
                        </li>
                      </ul>
                    </vs-alert>
                    <!--vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                    <router-link to="#">Forgot Password?</router-link-->
                  </div>
                  <vs-button class="my-5 float-right" v-if="!loginDisable">Login</vs-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import service from "./../../services";
import locale from "./../../locale";
import utils from "@/utils/list";

export default {
  data() {
    return {
      erroLogin: true,
      login: "",
      password: "",
      empresaSelecionada: false,
      sitekey: "6LdGqwYpAAAAAETqalNcG4gpdZsGoLp6qhMtxWhz",
      widgetId: 0,
      loginDisable: true,
      captchaIsOk: true,
      form: {
        login: null,
        senha: null,
        adm: true,
      },
      checkbox_remember_me: false,
      logo: "https://aliveplan.s3.amazonaws.com/images/logo-aliveplan.png",
    };
  },
  methods: {
    initCaptcha() {
      let sitekey = this.sitekey;
      const self = this;
      window.grecaptcha.ready(function () {
        window.grecaptcha.render("recaptcha", {
          sitekey: sitekey,
          callback: (response) => {
            self.onRecaptchaVerified(response);
          },
        });
      });
    },
    onRecaptchaVerified(response) {
      if (response) {
        this.captchaIsOk = true;
        this.loginDisable = false;
      }
    },
    resetRecaptcha() {
      console.log("reset");
      window.grecaptcha.reset();
      this.captchaIsOk = false;
      this.loginDisable = true;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit(evt) {
      //console.log(this.loginDisable);
      if (!this.captchaIsOk) return;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        if (this.captchaIsOk) {
          service
            .post("Login", "Autenticar", this.form)
            .then((res) => {
              this.carregando = false;
              console.log(res.data);
              localStorage.setItem("user-token", res.data.token);
              const decoded = utils.buscaToken();

              if (decoded && decoded.idPerfil === 3) {
                location.href = "/produtos";
              } else {
                location.href = "/dashboard";
              }
            })
            .catch((e) => {
              console.log(e);
              this.carregando = false;
              this.resetRecaptcha();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: e,
                color: "danger",
              });
            });
        } else {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Captcha Inválido!",
            color: "danger",
          });
        }
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    localStorage.removeItem("user-token");
    localStorage.removeItem("p");
    this.initCaptcha();
  },
};
</script>
